import {Drawer, Tabs} from '@mantine/core';
import {ActivityEventsTab} from './ActivityEventsTab';
import {SessionsTab} from './SessionsTab';
import {UserStateTab} from './UserStateTab';

interface DebugDrawerProps {
    opened: boolean;
    onClose: () => void;
}

export const DebugDrawer = ({opened, onClose}: DebugDrawerProps) => {
    return (
        <Drawer
            opened={opened}
            onClose={onClose}
            title="Debug Panel"
            position="right"
            size="xl"
        >
            <Tabs defaultValue="activity">
                <Tabs.List>
                    <Tabs.Tab value="activity">Activity Events</Tabs.Tab>
                    <Tabs.Tab value="sessions">Sessions</Tabs.Tab>
                    <Tabs.Tab value="userstate">User State</Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="activity" pt="md">
                    <ActivityEventsTab />
                </Tabs.Panel>

                <Tabs.Panel value="sessions" pt="md">
                    <SessionsTab />
                </Tabs.Panel>

                <Tabs.Panel value="userstate" pt="md">
                    <UserStateTab />
                </Tabs.Panel>
            </Tabs>
        </Drawer>
    );
};
